import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Newspaper, ArrowRight, Sparkles } from 'lucide-react'
import { translations } from '@/lib/translations'
import { fetchList, mediaUrl } from '@/lib/api'

export default function FeaturedBlogsSection({ language }) {
  const t = translations[language]
  const [posts, setPosts] = useState([])

  useEffect(() => {
    fetchList('/blog?featured=1&limit=3').then(setPosts).catch(() => setPosts([]))
  }, [])

  if (!posts.length) return null

  return (
    <section id="blog" className="px-4 py-10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/5 border border-primary/10 mb-6">
            <Sparkles className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary/80 uppercase tracking-wide">
              {t.blog?.badge || 'Insights'}
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-primary via-primary/80 to-secondary bg-clip-text text-transparent">
              {t.blog?.featuredTitle || 'Featured News'}
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.map((post) => (
            <article key={post.id} className="group rounded-2xl overflow-hidden bg-card border border-border hover:border-primary/40 transition-all">
              <div className="h-44 overflow-hidden bg-muted">
                {post.featuredImage ? (
                  <img src={mediaUrl(post.featuredImage)} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-primary/40">
                    <Newspaper className="w-10 h-10" />
                  </div>
                )}
              </div>
              <div className="p-5">
                <p className="text-xs text-primary mb-2">{post.category}</p>
                <h3 className="font-semibold text-lg mb-2 line-clamp-2">{post.title}</h3>
                <p className="text-sm text-muted-foreground line-clamp-3 mb-4">{post.excerpt}</p>
                <Link to={`/blog/${post.slug}`} className="inline-flex items-center gap-2 text-primary text-sm font-medium">
                  {t.blog?.readMore || 'Read more'} <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link to="/blog" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary text-primary-foreground font-medium hover:opacity-90">
            {t.blog?.viewAll || 'View all articles'}
          </Link>
        </div>
      </div>
    </section>
  )
}
